import * as React from "react";
import Box from "@mui/material/Box";
import CustomDataGrid from "../../Components/CustomDataGrid/CustomDataGrid";
import CustomBackdrop from "../../Components/CustomBackdrop/Barckdrop";
import PropTypes from "prop-types";
import axios from "axios";
import { genURL, genURLTEST } from "../../_getjson";

import moment from "moment/moment";
import "moment/locale/th";
import { Button, Tab, Tabs, Typography, Grid } from "@mui/material";

import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import {
  blackColor,
  defaultFont,
  grayColor,
} from "../../assets/jss/psstyle/psacount";
import CustomInput from "../../Components/CustomInput/CustomInput";

import ARMainGroupInput from "../../Components/CustomARMainGroup/ARMainGroupInput";
import CustomARSubGroup from "../../Components/CustomARSubGroup/CustomARSubgroup";

const from = "CSAR";
const columns = [
  { field: "id", headerName: "id", width: 40, hide: true },
  {
    field: "arCode",
    headerName: "รหัสลูกค้า",
    width: 200,
    editable: false,
  },
  {
    field: "arName",
    headerName: "ชื่อลูกค้า",
    width: 250,
    editable: false,
  },
  {
    field: "address",
    headerName: "ที่อยู่",
    width: 300,
    editable: false,
    flex: 1,
  },
  {
    field: "phoneNumber",
    headerName: "เบอร์ติดต่อ",
    width: 200,
    editable: false,
    flex: 1,
  },
];

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

export default function Rechecked(props) {
  const [state, setState] = React.useState({
    tabValue: 0,
    rows: [],
    openbackdrop: false,
    arSubGroup1: "",
    arMainGroup: "",
    rowList: "100",
  });

  const loadData = async (val, ConditionData) => {
    setState({
      ...state,
      openbackdrop: true,
    });
    // let url = ''
    // if (val === 'all') {
    // url = `CSPURCHASE/Search?top=100&startdate=${datestartdata != null ? datestartdata : ""}&enddate=${dateenddata != null ? dateenddata : ""}&startdocno=${docnostartdata != null ? docnostartdata : ""}&enddocno=${docnoenddata != null ? docnoenddata : ""}`
    // } else {
    let url = `CSAR/SearchData?ConditionData=${ConditionData}`;
    // }
    //console.log(genURL(url))
    let rs = await axios.get(genURL(url));
    //  let rs = await axios.get(genURLTEST(`/SearchData?ConditionData=${ConditionData}`), { timeout: 12000 })
    let element = [];

    if (rs.data.length > 0) {
      console.log("rs", rs.data);
      for (let index = 0; index < rs.data.length; index++) {
        await element.push({
          id: Number(index) + 1,
          docDate: moment(rs.data[index].DOCDATE).format("L"),
          arCode: rs.data[index].CODE,
          arName: rs.data[index].NAMETH,
          address: rs.data[index].ADDRESSTH,
          phoneNumber: rs.data[index].TELEPHONE,
        });
        // console.log("rs elementzzzzzzzzzzz", rs.data[index].code);
      }
    }

    // console.log("rsxxxxxxxxxxxxxxxxxxxxxxxxx", rs)

    await setState({
      ...state,
      rows: element,
      openbackdrop: false,
    });
  };
  const resData = (e) => {
    // console.log("resData resData", e)
  };
  const removeresData = (e) => {
    //  console.log("resData removeresData", e)
  };
  const selcetRow = async (e) => {
    await props.Dataselect(e);
    // console.log("selcetRow", e)
  };
  const SearchData = async () => {
    console.log("SearchData state", state);
    let ConditionData = await JSON.stringify([
      {
        ArMainGroup: state.arMainGroup, //e[1].arMainGroup,
        ArSubGroup1: state.arSubGroup1,
        Top: state.rowList,
      },
    ]);
    await loadData("all", ConditionData);
  };
  const setResData = async (e) => {
    await setState({
      ...state,
      rowList: e,
    });
  };

  const tabHandleChange = (event, newValue) => {
    setState({
      ...state,
      tabValue: newValue,
    });
    //  setTabValue(newValue);
  };

  const resultData = async (provenance, value) => {
    if (provenance == "ARMainGroupInput") {
      await setState({
        ...state,
        arMainGroup: value,
      });
    } else if (provenance == "arSubGroup1Input") {
      await setState({
        ...state,
        arSubGroup1: value.subCode,
      });
    }
  };
  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Grid container spacing={1}>
          <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
            <Button
              variant="outlined"
              startIcon={<SearchRoundedIcon />}
              sx={{
                pt: -5,
                height: "32px",
                mt: 1.4,
                borderColor: grayColor[11],
                color: blackColor[0],
                fontFamily: defaultFont,
              }}
              onClick={() => SearchData()}
              size="small"
            >
              ค้นหา
            </Button>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomInput
              inputType={"number"}
              id={"rowSelect"}
              label={`จำนวนรายการ`}
              placeholder={
                "ถ้าต้องการรายการทั้งหมดตามเงื่อนไขให้กรอก -1 ค่าเริ่มต้นเป็น 100"
              }
              resData={(e) => setResData(e)}
            />
          </Grid>
        </Grid>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={state.tabValue}
            onChange={tabHandleChange}
            aria-label="basic tabs example"
          >
            <Tab label="เงื่อนไข" {...a11yProps(0)} />
            {/* <Tab label={"ลูกหนี้"} {...a11yProps(1)} />
                        <Tab label="สินค้า" {...a11yProps(2)} /> */}
          </Tabs>{" "}
          {/*    */}
          <TabPanel value={state.tabValue} index={0}>
            <Grid container spacing={3}>
              <Grid item xs={6} sm={12} md={6} lg={4} xl={4}>
                <ARMainGroupInput
                  label={"กลุ่มลูกค้าหลัก"}
                  resultData={(e) => resultData("ARMainGroupInput", e)}
                  inputType={"text"}
                  keyDown={(e) => keyDown(e)}
                  defaultValue={state.arMainGroup}
                />
              </Grid>
              <Grid item xs={6} sm={12} md={6} lg={4} xl={4}>
                <CustomARSubGroup
                  resultData={(e) => resultData("arSubGroup1Input", e)}
                  inputType={"text"}
                  keyDown={(e) => keyDown(e)}
                  defaultValue={state.arSubGroup1}
                />
              </Grid>
            </Grid>
          </TabPanel>
        </Box>
        <Box>
          {state.rows.length > 0 ? (
            <CustomDataGrid
              datacolumns={columns}
              datarows={state.rows}
              rowHeight={38}
              Dataintable={(e) => resData(e)}
              Dataintableremove={(e) => removeresData(e)}
              startRow={1}
              option={[{ add: false, del: false, select: true }]}
              // checkboxSelection
              onRowClick={(e) => selcetRow([e.row])}
              // Dataselect={e => selcetRow(e)}

              RowsModelChange={(_) => console.log("RowsModelChange")}
              from={from}
            />
          ) : (
            <Grid container spacing={2}>
              <Grid item xs={12} textAlign={"center"}>
                ไม่พบข้อมูล
              </Grid>
            </Grid>
          )}
        </Box>
        <CustomBackdrop open={state.openbackdrop} />
      </Box>
    </>
  );
}
